import { render } from "./orariAperturaTicket.vue?vue&type=template&id=732d6e90&ts=true"
import script from "./orariAperturaTicket.vue?vue&type=script&lang=ts"
export * from "./orariAperturaTicket.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__